"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeMeetingsLibTracker = initializeMeetingsLibTracker;
exports.track = track;

var _usageTrackerPublic = require("usage-tracker-public");

var _events = _interopRequireDefault(require("MeetingsLib/events.yaml"));

var _strings = require("MeetingsBase/constants/strings");

var DEFAULT_LOCALE = 'en';
var tracker = null;
var screen = 'public';

function initializeMeetingsLibTracker(email, portalId, embedded, locale) {
  screen = embedded ? 'embedded' : 'public';
  tracker = (0, _usageTrackerPublic.createTracker)({
    events: _events.default,
    properties: {
      namespace: _strings.MEETINGS_APP_NAME,
      email: email,
      hubId: portalId,
      lang: locale || window.I18n ? window.I18n.locale : DEFAULT_LOCALE,
      screen: screen
    }
  });
  return tracker;
}

function track(eventKey) {
  var eventProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (tracker) {
    tracker.track(eventKey, Object.assign({
      screen: screen
    }, eventProperties));
  }
}